import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table'
class ProductLocations extends Component {

    constructor(props) {
        super(props);
        this.state = { productId: props.productId, loading: true, alertMessage: "", locationDetails: [] };
        this.history = props.history;
    }

    componentDidMount() {
        this.getProductLocations();
    }

    render() {
        return (
            <div>
                {this.state.loading && <div> <em>Loading ... </em></div>}
                {!this.state.loading && this.state.locationDetails.length == 0 && <div> <em>No inventory found for this product. </em></div>}
                {this.state.locationDetails.length > 0 && <div>
                    <div>
                        <span><b>Product:</b> {this.state.locationDetails[0].CODE}</span><br />
                        <span><b>Description:</b> {this.state.locationDetails[0].Description}</span><br />
                        <span><b>Species:</b> {this.state.locationDetails[0].Species}</span><br />
                    </div>
                    <Table responsive>
                        <thead>
                            <tr>
                                <td>Row</td>
                                <td>Col</td>
                                <td>Lev</td>
                                <td>Tray</td>
                                <td>SOH</td>
                                <td>Area</td>
                                <td>Grade1</td>
                                <td>Grade2</td>
                                <td>Grade3</td>
                                <td>Expiry</td>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.locationDetails.map((element, index) => (
                                <tr key={index}>
                                    <td>{element.NAME}</td>
                                    <td>{element.LOC_COLUMN}</td>
                                    <td>{element.LOC_LEVEL}</td>
                                    <td>{element.TRAY}</td>
                                    <td>{element.SOH}</td>
                                    <td>{element.Area}</td>
                                    <td>{element.Grade1}</td>
                                    <td>{element.Grade2}</td>
                                    <td>{element.Grade3}</td>
                                    <td>{typeof element.DT_EXPIRY === 'object' ? <em></em> : this.getDate(element.DT_EXPIRY)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>

                }
            </div>
        );
    }

    getDate(data) {
        try {          
            var inputDate = new Date(data  + 'Z');
            let date, month, year;
            date = inputDate.getDate();
            month = inputDate.getMonth() + 1;
            year = inputDate.getFullYear();
            date = date
                .toString()
                .padStart(2, '0');
            month = month
                .toString()
                .padStart(2, '0');
            return `${date}/${month}/${year}`;
        } catch (e) {
            return data;
        }
    }

    getProductLocations() {
        this.setState({ loading: true });
        fetch(`api/Enquiry/GetProductLocations?productId=${this.state.productId}`)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Cannot load product locations. " + errorText });
                }
                else {
                    this.setState({ loading: false, locationDetails: data });
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }
}
export default ProductLocations;
